import { Pill } from '@sixfold/common-ui';
import React from 'react';
import { NavLink } from 'react-router';

import { CompanyRelationship } from '../../company/entities';
import { CompanyRelationshipType } from '../../lib/graphql';
import { Routes } from '../../routes';

export const getRelationshipTypeLabel = (relationshipType: string): string =>
  relationshipType.toLowerCase().replace(/_/g, ' ');

function getRelationshipPillKind(relationshipType: CompanyRelationshipType): React.ComponentProps<typeof Pill>['kind'] {
  switch (relationshipType) {
    case CompanyRelationshipType.CARRIER:
      return 'info';
    case CompanyRelationshipType.REFERRER:
      return 'neutral';
    case CompanyRelationshipType.SUBCARRIER:
      return 'warning';
    case CompanyRelationshipType.COMPANY_GROUP:
      return 'success';
    default: {
      const exhaustive: never = relationshipType;
      return exhaustive;
    }
  }
}

export const RelationshipSnippet: React.FunctionComponent<{
  sourceCompany: Pick<CompanyRelationship['sourceCompany'], 'company_name' | 'company_id'> | null;
  relationshipType: CompanyRelationship['relationshipType'];
  targetCompany: CompanyRelationship['targetCompany'] | null;
}> = ({ sourceCompany, targetCompany, relationshipType }) => {
  return (
    <React.Fragment>
      {sourceCompany !== null && (
        <React.Fragment>
          <NavLink to={Routes.Company.generatePath({ company_id: sourceCompany.company_id })} className="item">
            {sourceCompany.company_name}
          </NavLink>

          <span style={{ margin: '0 4px' }}>
            {relationshipType === CompanyRelationshipType.COMPANY_GROUP ? 'is in the' : 'is'}
          </span>
        </React.Fragment>
      )}
      <Pill kind={getRelationshipPillKind(relationshipType)}>{getRelationshipTypeLabel(relationshipType)}</Pill>
      {targetCompany !== null && (
        <React.Fragment>
          <span style={{ margin: '0 4px' }}>of</span>
          <NavLink to={Routes.Company.generatePath({ company_id: targetCompany.company_id })} className="item">
            {targetCompany.company_name}
          </NavLink>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
